import { publicConfig } from "./config";
import { ENV_PROD, ENV_RC, ENV_STG } from "./constants";

const { BASE_SITE_DOMAIN } = publicConfig;

const routes = {
	nextJsInfo: "/nextjsinfo",
	errors: {
		403: "/403",
		404: "/404",
		default: "/error",
	},
	home: {
		url: "/",
		disabledEnv: [],
	},
	integrations: {
		dotmaticsLuma: {
			url: "/integrations/dotmatics-luma",
			disabledEnv: [],
		},
		dotmaticsLumaSuccess: {
			url: "/integrations/dotmatics-luma/success",
			disabledEnv: [],
		},
	},
	product: {
		subRoutes: {
			overview: {
				url: "/features/flow-cytometry-software",
				disabledEnv: [],
			},
			classicAnalysis: {
				url: "/features/flow-cytometry-software#classic-analysis",
				disabledEnv: [],
			},
			highDimensionalAnalysis: {
				url: "/features/flow-cytometry-software#high-dimensional-analysis",
				disabledEnv: [],
			},
			cloudPlatform: {
				url: "/features/flow-cytometry-software#cloud-platform",
				disabledEnv: [],
			},
			dataManagement: {
				url: "/features/flow-cytometry-software#data-management",
				disabledEnv: [],
			},
			prismIntegration: {
				url: "/features/prism-integration",
				disabledEnv: [],
			},
			easyPanelIntegration: {
				url: "/features/easypanel-integration",
				disabledEnv: [],
			},
		},
	},
	solutions: {
		subRoutes: {
			enterprise: {
				url: "/enterprise",
				disabledEnv: [],
			},
			customAutogating: {
				url: "/features/custom-autogating",
				disabledEnv: [],
			},
			omiqLuma: {
				url: "/luma",
				disabledEnv: [],
			},
		},
	},
	resources: {
		url: "/resources",
		disabledEnv: [],
		subRoutes: {
			gettingStarted: {
				url: "/series/getting-started",
				disabledEnv: [],
			},
			userGuides: {
				url: "https://help.omiq.ai/hc/en-us/categories/4417056891668",
				disabledEnv: [],
			},
		},
	},
	features: {
		url: "/features",
		disabledEnv: [],
	},
	contact: {
		index: "/contact",
		success: "/contact/success",
	},
	guides: {
		disabledEnv: [],
		subRoutes: {
			tutorial: {
				url: "/guides/cytometry-analysis-tutorial",
				disabledEnv: [],
			},
		},
	},
	series: {
		disabledEnv: [],
		subRoutes: {
			gettingStarted: {
				url: "/resources#getting-started",
				disabledEnv: [],
			},
		},
	},
	updates: {
		url: "/updates",
		disabledEnv: [],
	},
	support: {
		url: "https://help.omiq.ai/",
		disabledEnv: [],
	},
	dotmatics: {
		url: "https://www.dotmatics.com/",
		disabledEnv: [],
	},
	portfolio: {
		url: "https://www.dotmatics.com/portfolio",
		disabledEnv: [],
	},
	careers: {
		url: "https://www.dotmatics.com/about-careers",
		disabledEnv: [],
	},
	customers: {
		url: "/customers",
		disabledEnv: [ENV_RC, ENV_STG, ENV_PROD],
	},
	termsOfService: {
		url: "/terms-of-service",
		disabledEnv: [],
	},
	twitter: "https://twitter.com/omiq_ai",
	linkedIn: "https://www.linkedin.com/company/omiq/",
	privacyPolicy: {
		url: "/privacy-policy",
		disabledEnv: [],
	},
	freeTrial: {
		url: "https://app.omiq.ai/login?om_requested_trial=true",
		disabledEnv: [],
	},
	about: {
		url: "/about",
		disabledEnv: [],
		subRoutes: {
			contact: {
				url: "/contact",
				disabledEnv: [],
			},
		},
	},
	purchase: {
		academic: "/purchase/select-seats?planCode=om_standard_academic_yearly",
		corporate: "/purchase/select-seats?planCode=om_standard_corporate_yearly",
		student: "/purchase/select-seats?planCode=om_student_yearly",
		base: "/purchase/",
		selectSeats: "/purchase/select-seats",
		billing: "/purchase/billing",
		success: "/purchase/success",
	},
	invoice: {
		pay: "/invoice/pay",
		success: "/invoice/pay-success",
		invalid: "/invoice/invalid",
	},
	pricing: {
		url: "/pricing",
		students: "/pricing#students",
		disabledEnv: [],
	},
	quoteRequest: {
		url: "https://help.omiq.ai/hc/en-us/requests/new?ticket_form_id=9286049746580",
		disabledEnv: [],
	},
	contactSupport: {
		url: "https://help.omiq.ai/hc/en-us/requests/new?ticket_form_id=9319692139540",
		disabledEnv: [],
	},
	helpCenter: {
		url: "https://help.omiq.ai/hc/en-us",
		disabledEnv: [],
	},
	signIn: {
		url: "https://app.omiq.ai/",
		disabledEnv: [],
	},
	cookieNotice: {
		url: "/cookie-notice",
		disabledEnv: [],
	},
	external: {
		index: `//${BASE_SITE_DOMAIN}/`,
		freeTrial: "https://app.omiq.ai/login?om_requested_trial=true",
		termsOfService: `//${BASE_SITE_DOMAIN}/terms-of-service`,
		privacyPolicy: `//www.dotmatics.com/privacy-policy`,
		downloadApp: `//app.${BASE_SITE_DOMAIN}/`,
		help: "https://help.omiq.ai/hc/en-us/requests/new",
		platform: "//www.dotmatics.com/platform",
		dotmatics: "//www.dotmatics.com/",
		portfolio: "//www.dotmatics.com/portfolio",
		products: {
			prism:
				"//www.graphpad.com/?utm_medium=referral&utm_source=omiq&utm_campaign=dotmatics-top-bar",
			geneious:
				"//www.geneious.com/?utm_medium=referral&utm_source=omiq&utm_campaign=dotmatics-top-bar",
			snapgene:
				"//www.snapgene.com/?utm_medium=referral&utm_source=omiq&utm_campaign=dotmatics-top-bar",
			labArchives:
				"//www.labarchives.com/?utm_medium=referral&utm_source=omiq&utm_campaign=dotmatics-top-bar",
			proteinMetrics:
				"//proteinmetrics.com/?utm_medium=referral&utm_source=omiq&utm_campaign=dotmatics-top-bar",
			omiq: "//www.omiq.ai/?utm_medium=referral&utm_source=omiq&utm_campaign=dotmatics-top-bar",
			fcsExpress:
				"//denovosoftware.com/?utm_medium=referral&utm_source=omiq&utm_campaign=dotmatics-top-bar",
			nQuery:
				"//www.statsols.com/?utm_medium=referral&utm_source=omiq&utm_campaign=dotmatics-top-bar",
		},
		doNotSell: "https://donotsell.dotmatics.com/hc/en-us/requests/new",
		tryForFree:
			"https://app.omiq.ai/login?utm_campaign=GP+-+Marketing+-+OM+Cross+Sell&utm_source=Prism+OMIQ+LP+Referral&utm_medium=om+lp",
		trademarks: "https://www.dotmatics.com/trademarks",
		whistleblowing: "https://app.goethena.com/hotline/ecca9d8d",
	},
};

export default routes;
